module.exports = "//public.getcloudapp.com/packs/media/images/close-icon-e27124fc3f3f7cff664d6a5cf83b8782.svg";